import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const Header = () => {
  const { language, toggleLanguage, t, isRTL } = useLanguage();
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    fetch('/syrverse-loop3.json')
      .then(response => response.json())
      .then(data => setAnimationData(data))
      .catch(err => console.error('Failed to load animation:', err));
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header 
      className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
        <div className="flex items-center">
          {animationData ? (
            <div className="w-32 h-12">
              <Lottie
                animationData={animationData}
                loop={true}
                autoplay={true}
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          ) : (
            <div className="w-32 h-12 animate-pulse bg-white/10 rounded"></div>
          )}
        </div>

        <nav className="hidden md:flex items-center gap-8">
          <button 
            onClick={() => scrollToSection('hero')}
            className="text-white/70 hover:text-white transition-colors duration-300 text-lg"
          >
            {t.nav.home}
          </button>
          <button 
            onClick={() => scrollToSection('apps')}
            className="text-white/70 hover:text-white transition-colors duration-300 text-lg"
          >
            {t.nav.apps}
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className="text-white/70 hover:text-white transition-colors duration-300 text-lg"
          >
            {t.nav.about}
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="text-white/70 hover:text-white transition-colors duration-300 text-lg"
          >
            {t.nav.contact}
          </button>
        </nav>

        <button
          onClick={toggleLanguage}
          className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-none transition-all duration-300 text-white"
        >
          <Globe size={18} />
          <span className="font-medium">{language === 'ar' ? 'EN' : 'عربي'}</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
